// extracted by mini-css-extract-plugin
export default {"logout":"phdB17qv","userInfo":"NHCbOtDM","userIcon":"QRaljEmP","loginName":"nkVQwlat","logoutIcon":"_iP8zBWd"};